module.exports = __webpack_public_path__ + "b82e6d4ba99ab972d8e2f74c677deae2.jpeg";